import { publicConfigQuery$ } from '@psl/functions/firebase/queries/public-config/publicConfigQuery$';
import { Linking, Platform } from 'react-native';
import { firstValueFrom } from 'rxjs';
import { makeDebug } from '../../../utils/makeDebug';
import { currentUserId } from '../../auth/utils';
import { isDebugEnabled } from '../../debugging';
import {
  tryCaptureCampaignId,
  utmParameters$,
} from '../../dynamic-links/campaignTracker';
import type { PathResolveResult } from '../PathResolver';

let initialPath: string | undefined = undefined;
let initialUrl: string | null = null;

let initialState: PathResolveResult | undefined = undefined;

const debug = makeDebug('initial-url', isDebugEnabled('linking'));

export function getInitialPath() {
  return initialPath;
}

export function setInitialPath(path: string) {
  const searchParams = Object.fromEntries(
    new URLSearchParams(path.split('?')[1]),
  );
  if (searchParams['utm_campaign']) {
    const utm_params = Object.fromEntries(
      Object.keys(searchParams)
        .filter(
          x => x.startsWith('utm_') && typeof searchParams[x] === 'string',
        )
        .map(k => [k, searchParams[k] as string]),
    );
    utmParameters$.next(utm_params);
    debug('initialized with utm parameters: %O', searchParams);
  }
  initialPath = path;
}

export const resolveInitialUrl = async () => {
  const url = await Linking.getInitialURL();
  initialUrl = url;
  if (!url) {
    return url;
  }

  tryCaptureCampaignId(url);

  if (Platform.OS !== 'web') {
    const publicConfig = await firstValueFrom(publicConfigQuery$);
    const authRequired = publicConfig.auth?.required_for_mobile !== false;

    const userId = currentUserId();
    if (!userId && authRequired) {
      return '/login';
    }
  }
  return url;
};

export function updateInitialUrl(url: string | null) {
  initialUrl = url;
}

export function getInitialUrl() {
  return initialUrl;
}

export function setInitialState(value: PathResolveResult) {
  initialState = value;
}

export function getInitialState() {
  return initialState;
}
